export default __webpack_public_path__ + "static/media/group_purple_24px.625e4d9f.svg";